///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const CloseFullScreenIcon = ({
  height,
  width,
  title = messages.closeFullScreen.defaultMessage
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="close-fullscreen"
  >
    <title id="closeFullScreen-icon">{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h18v18H0z" />
      <path
        d="M16.5 2.5575L12.5325 6.525 15 9H9V3l2.4675 2.4675L15.4425 1.5 16.5 2.5575zM2.5575 16.5l3.9675-3.9675L9 15V9H3l2.4675 2.4675L1.5 15.4425 2.5575 16.5z"
        fill="#000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default CloseFullScreenIcon;
